/**
 * @voltxampere/ui — RotateCommand (Sprint 18 Paket C C3)
 *
 * Rotate a single component 90° clockwise per invocation. Multi-
 * select rotation goes through `BatchCommand` so the whole batch
 * lands as one undoable step (mirrors MoveCommand semantics).
 *
 * The command carries both `from` and `to` rotation values so
 * `undo()` is exact — even when the component's pre-rotation
 * differs from a fresh 0° (a previously-rotated symbol that the
 * user is rotating again). The schema's rotation type is the
 * usual 0 / 90 / 180 / 270 quartet.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class RotateCommand {
    componentId;
    fromRotation;
    toRotation;
    constructor(componentId, fromRotation, toRotation) {
        this.componentId = componentId;
        this.fromRotation = fromRotation;
        this.toRotation = toRotation;
    }
    do(circuit) {
        return {
            ...circuit,
            components: circuit.components.map((c) => c.id === this.componentId ? { ...c, rotation: this.toRotation } : c),
        };
    }
    undo(circuit) {
        return {
            ...circuit,
            components: circuit.components.map((c) => c.id === this.componentId ? { ...c, rotation: this.fromRotation } : c),
        };
    }
    describe() {
        return "Döndürüldü";
    }
}
/** Pure helper: map the current rotation to the next 90°-clockwise
 *  step. Exposed for unit tests + shared between the canvas
 *  shortcut handler and the inspector button. */
export function nextRotation(current) {
    switch (current) {
        case 0:
            return 90;
        case 90:
            return 180;
        case 180:
            return 270;
        case 270:
            return 0;
    }
}
//# sourceMappingURL=rotate.js.map